import { fabric } from "fabric";

export class CalligraphyBrush extends fabric.BaseBrush {
  constructor(canvas) {
    super();
    this.canvas = canvas;
    this.width = 20;
    this.color = "#000";
    this.angle = -45;
    this._points = [];
  }

  onMouseDown(pointer) {
    this._points = [pointer];
  }

  onMouseMove(pointer) {
    if (!this._points.length) return;
    this._points.push(pointer);
    this._render();
  }

  onMouseUp() {
    if (this._points.length < 2) return;

    const pathData = this._buildPath();
    const path = new fabric.Path(pathData, {
      stroke: this.color,
      strokeWidth: this.width,
      fill: null,
      strokeLineCap: "butt", // flat end
      strokeLineJoin: "bevel",
      selectable: true,
      evented: true,
    });

    this.canvas.add(path);
    this.canvas.requestRenderAll();

    this._points = [];
  }

  _render() {
    const ctx = this.canvas.contextTop;
    this.canvas.clearContext(ctx);

    ctx.fillStyle = this.color;
    for (let i = 1; i < this._points.length; i++) {
      const p1 = this._points[i - 1];
      const p2 = this._points[i];
      this._drawNib(ctx, p1.x, p1.y, p2.x - p1.x, p2.y - p1.y);
    }
  }

  _drawNib(ctx, x, y, dx, dy) {
    const angle = Math.atan2(dy, dx);
    const nibAngle = angle + (this.angle * Math.PI) / 180;

    const nibWidth = this.width;
    const nibHeight = this.width / 4;

    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(nibAngle);
    ctx.fillRect(-nibWidth / 2, -nibHeight / 2, nibWidth, nibHeight);
    ctx.restore();
  }

  _buildPath() {
    let d = "";
    for (let i = 0; i < this._points.length; i++) {
      const p = this._points[i];
      d += i === 0 ? `M ${p.x} ${p.y} ` : `L ${p.x} ${p.y} `;
    }
    return d;
  }
}